import { render, staticRenderFns } from "./MissedQuestions.vue?vue&type=template&id=342ff9ec"
import script from "./MissedQuestions.vue?vue&type=script&lang=js"
export * from "./MissedQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports